import React from 'react';
import {createRoot} from 'react-dom/client';
import ReactQueryProvider from './providers/QueryClientProvider';
import App from './App';
import ErrorBoundary from './components/Common/ErrorBoundary';
import {DarkModeProvider} from './contexts/DarkModeContext';
import './i18n';
import './index.css';

const root = createRoot(document.getElementById('root'));
root.render(
    <ErrorBoundary>
        <ReactQueryProvider>
            <DarkModeProvider>
                <App/>
            </DarkModeProvider>
        </ReactQueryProvider>
    </ErrorBoundary>
);

